import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import Divider from 'material-ui/Divider';

import * as Colors from 'material-ui/styles/colors';
import Gravatar from 'react-gravatar';

import AccessGroupIcon from 'material-ui/svg-icons/editor/bubble-chart';
import AssetIcon from 'material-ui/svg-icons/file/folder';
import AssignmentIcon from 'material-ui/svg-icons/action/assignment-ind';
import CertificateIcon from 'material-ui/svg-icons/action/verified-user';
import ComplianceIcon from 'material-ui/svg-icons/action/assignment-turned-in';
import ContactsIcon from 'material-ui/svg-icons/communication/contacts';
import EmailIcon from 'material-ui/svg-icons/content/drafts';
import FilterIcon from 'material-ui/svg-icons/content/filter-list';
import HelpIcon from 'material-ui/svg-icons/action/help';
import HomeIcon from 'material-ui/svg-icons/action/home';
import IconOrganisation from 'material-ui/svg-icons/social/domain';
import LabelIcon from "material-ui/svg-icons/action/label";
import LibraryIcon from 'material-ui/svg-icons/maps/local-library';
import ListIcon from 'material-ui/svg-icons/action/list';
import ModuleIcon from 'material-ui/svg-icons/action/view-module';
import PeopleIcon from 'material-ui/svg-icons/social/people';
import PersonIcon from 'material-ui/svg-icons/social/person';
import PublicIcon from 'material-ui/svg-icons/social/public';
import ProgrammeIcon from 'material-ui/svg-icons/action/assignment';
import ReportIcon from 'material-ui/svg-icons/action/assessment';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import VendorIcon from 'material-ui/svg-icons/places/business-center';
import VenueIcon from 'material-ui/svg-icons/communication/location-on';
import { ListItem } from 'material-ui/List';

import MuiDrawer from 'material-ui/Drawer';
import { formatName, shortNameFields } from '../../utils/StringUtils';
import Subheader from 'material-ui/Subheader';

const style = {
    menu: {
        marginRight: 32,
        marginBottom: 32,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    rightIcon: {
        textAlign: 'center',
        lineHeight: '24px',
    },
    avatar: {
        borderRadius: '50%'
    },
};


const Drawer = ({open, onRequestChange}, {auth}) => {
    const isAdmin = auth.isAdmin();
    const isManager = auth.isManager();

    const primaryColour = 'rgb(35, 151, 190)';

    const fullName = formatName(auth.identity, { fields: shortNameFields });

    let menuOptions = '';

    if (isManager) {
        menuOptions = '';
    }

    if (isAdmin) {

        menuOptions = (
            <section>
                <Divider/>
                <Subheader>Training</Subheader>
                <Link
                    key='compliance'
                    onClick={onRequestChange}
                    to='/dashboard/compliances'
                >
                    <ListItem
                        primaryText='Compliance'
                        leftIcon={
                            <ComplianceIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='21'
                    onClick={onRequestChange}
                    to='/dashboard/programmes'
                >
                    <ListItem
                        primaryText='Programmes'
                        leftIcon={
                            <ProgrammeIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='22'
                    onClick={onRequestChange}
                    to='/dashboard/courses'
                >
                    <ListItem
                        primaryText='Courses'
                        leftIcon={
                            <SchoolIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='23'
                    onClick={onRequestChange}
                    to='/dashboard/modules'
                >
                    <ListItem
                        primaryText='Modules'
                        leftIcon={
                            <ModuleIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='24'
                    onClick={onRequestChange}
                    to='/dashboard/assignments'
                >
                    <ListItem
                        primaryText='Assignments'
                        leftIcon={
                            <AssignmentIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='25'
                    onClick={onRequestChange}
                    to='/dashboard/filters'
                >
                    <ListItem
                        primaryText='Filters'
                        leftIcon={
                            <FilterIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='26'
                    onClick={onRequestChange}
                    to='/dashboard/reports'
                >
                    <ListItem
                        primaryText='Reports'
                        leftIcon={
                            <ReportIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='27'
                    onClick={onRequestChange}
                    to='/dashboard/skills'
                >
                    <ListItem
                        primaryText='Skills'
                        leftIcon={
                            <PublicIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='28'
                    onClick={onRequestChange}
                    to='/dashboard/certificates'
                >
                    <ListItem
                        primaryText='Certificates'
                        leftIcon={
                            <CertificateIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='29'
                    onClick={onRequestChange}
                    to='/dashboard/trainers'
                >
                    <ListItem
                        primaryText='Trainers'
                        leftIcon={
                            <PersonIcon color={primaryColour}/>
                        }
                    />
                </Link>

                <Divider/>
                <Subheader>Admin</Subheader>

                <Link
                    key='32'
                    onClick={onRequestChange}
                    to='/dashboard/users'
                >
                    <ListItem
                        primaryText='Users'
                        leftIcon={
                            <PersonIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='33'
                    onClick={onRequestChange}
                    to='/dashboard/usergroups'
                >
                    <ListItem
                        primaryText='Groups'
                        leftIcon={
                            <PeopleIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='35'
                    onClick={onRequestChange}
                    to='/dashboard/organisations'
                >
                    <ListItem
                        primaryText='Organisations'
                        leftIcon={
                            <IconOrganisation color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='36'
                    onClick={onRequestChange}
                    to='/dashboard/venues'
                >
                    <ListItem
                        primaryText='Venues'
                        leftIcon={
                            <VenueIcon color={primaryColour}/>
                        }
                    />
                </Link>
                {auth.isRoot() && (
                    <Link
                        key='38'
                        onClick={onRequestChange}
                        to='/dashboard/accessgroups'
                    >
                        <ListItem
                            primaryText='Access groups'
                            leftIcon={
                                <AccessGroupIcon color={primaryColour}/>
                            }
                        />
                    </Link>
                )}
                <Link
                    key='39'
                    onClick={onRequestChange}
                    to='/dashboard/vendors'
                >
                    <ListItem
                        primaryText='Vendors'
                        leftIcon={
                            <VendorIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='61'
                    onClick={onRequestChange}
                    to='/dashboard/contacts'
                >
                    <ListItem
                        primaryText='Contacts'
                        leftIcon={
                            <ContactsIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='62'
                    onClick={onRequestChange}
                    to='/dashboard/library/list'
                >
                    <ListItem
                        primaryText='Categories'
                        leftIcon={
                            <ListIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='63'
                    onClick={onRequestChange}
                    to='/dashboard/assets'
                >
                    <ListItem
                        primaryText='Assets'
                        leftIcon={
                            <AssetIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='64'
                    onClick={onRequestChange}
                    to='/dashboard/email/templates'
                >
                    <ListItem
                        primaryText='Email templates'
                        leftIcon={
                            <EmailIcon color={primaryColour}/>
                        }
                    />
                </Link>
                <Link
                    key='65'
                    onClick={onRequestChange}
                    to='/dashboard/labels'
                >
                    <ListItem
                        primaryText='Labels'
                        leftIcon={
                            <LabelIcon color={primaryColour}/>
                        }
                    />
                </Link>
                { auth.isRoot() && (
                    <Link
                        key='69'
                        onClick={onRequestChange}
                        to='/dashboard/settings'
                    >
                        <ListItem
                            primaryText='Settings'
                            leftIcon={
                                <SettingsIcon color={primaryColour}/>
                            }
                        />
                    </Link>
                )}

            </section>
        );
    }

    return (
        <MuiDrawer
            className="cent-drawer"
            docked={false}
            open={open}
            onRequestChange={onRequestChange}
        >
            <header id="centIdentifier">
                <Gravatar
                    email={auth.identity.email}
                    default='https://cdn.premierit.com/images/icons/contact.png'
                    size={50}
                    style={style.avatar}
                />
                <div className="cent-username">
                    <Link
                        onClick={onRequestChange}
                        to='/dashboard/profile'
                    >
                        {fullName}<br/>
                        ({auth.identity.username})
                    </Link>
                </div>
            </header>
            <Link
                key='1'
                onClick={onRequestChange}
                to='/dashboard'
            >
                <ListItem
                    primaryText='Home'
                    leftIcon={<HomeIcon color={primaryColour}/>}
                />
            </Link>
            <Link
                key='2'
                onClick={onRequestChange}
                to='/dashboard/mytraining'
            >
                <ListItem
                    primaryText='My training'
                    leftIcon={<SchoolIcon color={primaryColour}/>}
                />
            </Link>
            <Link
                key='3'
                onClick={onRequestChange}
                to='/dashboard/library'
            >
                <ListItem
                    primaryText='Library'
                    leftIcon={<LibraryIcon color={primaryColour}/>}
                />
            </Link>

            {menuOptions}

            <Divider/>
            <Link
                key='100'
                onClick={onRequestChange}
                to='/dashboard/help'
            >
                <ListItem
                    primaryText="Help"
                    leftIcon={
                        <HelpIcon color={Colors.blueGrey300}/>
                    }
                />
            </Link>
        </MuiDrawer>
    );
};

Drawer.propTypes = {
    open: PropTypes.bool,
    onRequestChange: PropTypes.func.isRequired
};

Drawer.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default Drawer;
